import { COLOR_TEXT_MAIN } from '../../../../theme/colors';

const EventTrackingIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 20 31" width="24px" fill={COLOR_TEXT_MAIN}>
    <path
      d="M7.5 1H16.5L12.5 11H21L7.5 32L11 18H1L7.5 1Z"
      fill="#4C566C"
      stroke="#4C566C"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
);

export default EventTrackingIcon;
